import { DOMNode, Element } from 'html-react-parser'

export const isElement = (domNode: DOMNode): domNode is Element =>
  domNode.type === 'tag' && (domNode as Element).attribs !== undefined
